/**
 * Common texts - what is CamAPS FX
 */
export const whatIsCamAPSFX = {

    linkFindOutMore: 'Find out more',
    body:
        '<h2>What is CamAPS FX?</h2> ' +
        '<p> ' +
        '    CamAPS FX is an Android app to manage glucose levels in ' +
        '    people with type 1 diabetes using ' +
        '    an advanced adaptive hybrid closed-loop approach. ' +
        '</p>'
};

/**
 * Common texts - what is CamAPS FX
 */
export const userReviewsIntro = {
    linkMoreReviews: 'More Stories',
    readMore: 'Read more',
    header:
        'User Stories',
    text:
        'Real people. Real experiences.'
};